export default __webpack_public_path__ + "static/media/usd.04530076.svg";